export const CopilotFeatureEnablementCodes = {
    COPILOT_DISABLED_PRIVACY_POLICY: 'D_PrivacyPolicy',
    COPILOT_DISABLED_ARCHIVE_MAILBOX: 'D_ArchiveMailbox',
    COPILOT_DISABLED_SHARED_OR_DELEGATE_MAILBOX: 'D_SharedOrDelegateMailbox',
    COPILOT_DISABLED_SERVICE_REQUEST_UNSUPPORTED_FOR_MAILBOX:
        'D_ServiceRequestUnsupportedForMailbox',
    COPILOT_DISABLED_USER_SETTING: 'D_UserSettings',
    COPILOT_STORE_NOT_ENABLED: 'D_StoreNotEnabled',
    COPILOT_STORE_FEATURE_NOT_ENABLED: 'D_StoreFeatureNotEnabled',
    COPILOT_DISABLED_ECS: 'D_ECS',
    COPILOT_UNSUPPORTED_LANGUAGE: 'D_UnsupportedLanguage',
} as const;

export type CopilotFeatureEnablementCode =
    typeof CopilotFeatureEnablementCodes[keyof typeof CopilotFeatureEnablementCodes];
